export { default as Restricted } from './restricted';



// WEBPACK FOOTER //
// ./src/icon/svgs/permissions/index.js